import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../App";
import {
  JWT_TOKEN,
  USER_EMAIL_ID,
  USER_ID,
  USER_NAME,
  USER_ORG_ID,
} from "../../Constants/StorageConstants";
import AxiosInstance from "../../services/AxiosInstance";

export function useOtpVerification(tempToken, onSuccess) {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const { updateAuthStatus } = useContext(AuthContext);

  const handleVerifyOtp = async () => {
    if (!otp || otp.length !== 6) {
      setError("Please enter a valid 6-digit OTP");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await AxiosInstance.post("/api/auth/verify-otp", {
        token: tempToken,
        otp: parseInt(otp),
      });

      const userData = response.data;

      // Store user data in localStorage
      localStorage.setItem(JWT_TOKEN, userData.token);
      localStorage.setItem(USER_NAME, userData.name);
      localStorage.setItem(USER_ID, userData.id);
      localStorage.setItem(USER_ORG_ID, userData.orgId);
      localStorage.setItem(USER_EMAIL_ID, userData.emailId);

      updateAuthStatus();
      onSuccess();
      navigate("/home");
    } catch (error) {
      setError("Invalid OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && otp.length === 6 && !loading) {
      handleVerifyOtp();
    }
  };

  const resetOtp = () => {
    setOtp("");
    setError("");
  };

  return {
    otp,
    setOtp,
    loading,
    error,
    setError,
    handleVerifyOtp,
    handleKeyPress,
    resetOtp,
  };
}
